// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import Practice from './pages/Practice/Practice';
import Discover from './pages/Discover/Discover';
import Sessions from './pages/Sessions/Sessions';
import Settings from './pages/Settings/Settings';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import AdminLayout from './components/AdminLayout';
import { UserManagement } from './pages/AdminDashboard/UserManagement';
import { FeedbackManagement } from './pages/AdminDashboard/FeedbackManagement';
import { AnalyticsManagement } from './pages/AdminDashboard/AnalyticsManagement';
import { TunerManagement } from './pages/AdminDashboard/TunerManagement';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword'; // Change to default import
import ResetPassword from './pages/ResetPassword/ResetPassword';
import Upgrade from './pages/Upgrade/Upgrade';
import UserProfile from './pages/UserProfile/UserProfile';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Routes>
                  <Route path="/" element={<AdminDashboard />} />
                  <Route path="users" element={<UserManagement />} />
                  <Route path="feedback" element={<FeedbackManagement />} />
                  <Route path="analytics" element={<AnalyticsManagement />} />
                  <Route path="tuner" element={<TunerManagement />} />
                </Routes>
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/practice" replace />} />
        <Route
          path="/practice"
          element={
            <ProtectedRoute>
              <Layout>
                <Practice />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sessions"
          element={
            <ProtectedRoute>
              <Layout>
                <Sessions />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Layout>
                <Settings />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <UserProfile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/upgrade" element={<Upgrade />} />
      </Routes>
    </Router>
  );
}

export default App;